import { Component, EventEmitter, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { GeneralAvailabilityCalendarComponent } from '../../../modules/pages/tutor-profile/components/general-availability-calendar/general-availability-calendar.component';

@Component({
  selector: 'app-tutor-availability-dialog',
  standalone: true,
  imports: [TranslateModule, GeneralAvailabilityCalendarComponent],
  templateUrl: './tutor-availability-dialog.component.html',
  styleUrl: './tutor-availability-dialog.component.scss'
})
export class TutorAvailabilityDialogComponent {
  @Output() onConfirm = new EventEmitter<void>();
  @Output() onClose = new EventEmitter<void>();
}
